up.compiler('input:not([type=hidden])', input => {
  function setCustomValidity(input, error) {
    if (error) {
      input.setCustomValidity(error)
    }
  }

  function resetCustomValidity(input, error) {
    input.setCustomValidity('')
  }

  function prependInputLabel(target, error) {
    if (target.id) {
      const label = document.querySelector(`[for="${target.id}"]`)

      // ignore really long labels
      // TODO: a way to provide a custom per-field error message
      if (label && label.innerText && label.innerText.length < 80) {
        return `${label.innerText} ${error}`
      }

      return error
    }
  }

  input.addEventListener('invalid', e => {
    if (!window.steadyI18n) {
      return
    }

    if (input.required && e.target.validity.valueMissing) {
      let error = window.steadyI18n.errors.required
      error = prependInputLabel(e.target, error)

      setCustomValidity(e.target, error)
    } else if (input.minLength > 0 && e.target.validity.tooShort) {
      let error = window.steadyI18n.errors.tooShort
      error = error.replace('123456789', input.minLength)
      error = prependInputLabel(e.target, error)

      setCustomValidity(e.target, error)
    } else if (input.type === 'email' && e.target.validity.typeMismatch) {
      const error = window.steadyI18n.errors.invalidEmail

      setCustomValidity(e.target, error)
    }
  })

  input.addEventListener('change', e => {
    resetCustomValidity(e.target)
  })
})
